
        Component.define('section-services', (el, params) => {
            /**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el             = $(el);
const $slider         = $el.find('.slider-services');

$slider.slick({
    autoplay: false,
    autoplaySpeed: 5000,
    slidesToShow: 4,
    prevArrow: '<button type="button" class="slick-arrow slick-prev" aria-label="Anterior"><svg><use xlink:href="#svg-arrow-simple" xlink:title="Anterior" /></svg></button>',
    nextArrow: '<button type="button" class="slick-arrow slick-next" aria-label="Próximo"><svg><use xlink:href="#svg-arrow-simple" xlink:title="Próximo" /></svg></button>',

    responsive: [
        {
            breakpoint: 1367,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 1281,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 476,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

        });